import { throttle } from 'lodash';

import { restartTimer } from '../actions/inactivityWarning';
import { isUserLoggedIn } from 'apps/user/helpers';

class DataSync {
  constructor() {
    this.actions = {};
  }

  trigger() {
    // reset inactivity warning timer
    if (isUserLoggedIn(this.store.getState().user)) {
      this.store.dispatch(restartTimer());
    }
    this.triggerActions();
  }

  triggerActions() {
    const errors = [];
    for (const key of Object.keys(this.actions)) {
      try {
        this.actions[key]();
      } catch (e) {
        errors.push(e);
      }
    }
    if (errors.length) {
      throw new Error(
        `DataSync.triggerActions: there were errors while processing actions list.\n ${errors.join('\n')}`
      );
    }
  }

  appendAction(actionId, action, throttleWait = 0) {
    if (!actionId || typeof actionId !== 'string') {
      throw new Error(`DataSync.appendAction: appended actionId is empty or isn't a string. ${actionId}`);
    }

    if (this.actions[actionId]) {
      throw new Error(`DataSync.appendAction: appended actionId already exists. ${actionId}`);
    }

    if (typeof action !== 'function') {
      throw new Error(`DataSync.appendAction: appended action is not a function.\n${actionId}: ${action}`);
    }

    this.actions[actionId] = throttle(() => {
      this.store.dispatch(action());
    }, throttleWait);
  }

  removeAction(actionId) {
    if (!this.actions[actionId]) {
      throw new Error(`DataSync.removeAction: action not appended.\n${actionId}`);
    }
    delete this.actions[actionId];
  }

  setStore(store) {
    this.store = store;
  }
}

const dataSync = typeof window !== 'undefined' ? new DataSync() : null;

export default dataSync;
